import {SearchModel} from "@fedeltapointofsale/data-client";
import {Injectable, Injector} from "@angular/core";

@Injectable()
export class AccountPaymentDetailsSearchModel extends SearchModel<any> {
    constructor(injector: Injector) {
        super(injector);
    }
}
